import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-logo',
    template: `
        <div class="logo-container">
            <ng-container *ngIf="logoUrl; else defaultLogo">
                <img [src]="logoUrl" alt="Logo" class="tenant-logo" [height]="56" [width]="56" />
            </ng-container>

            <ng-template #defaultLogo>
                <img src="assets/images/auth/factorkpi-logo-circle.svg" width="100" height="100" alt="FactorKPI - Smart Performance Management" />
            </ng-template>
        </div>
    `,
    imports: [NgIf],
    styles: [
        `
            .logo-container {
                width: 56px;
                height: 56px;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            :host {
                display: inline-block;
            }

            .tenant-logo {
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
            }
        `
    ]
})
export class Logo {
    @Input() logoUrl: string | null | undefined;
}
